import * as S from './style';

interface IProps {
  /** children */
  children?: React.ReactNode;
}

const Container = ({ children }: IProps) => (
  <S.Container id="container">
    <div className="content">{children}</div>
  </S.Container>
);

export default Container;
